export class Activity {

    public _id: string;
    public name: string;
    public countdown: number;
    public sequence: any[];
    public song: string;

    constructor() { }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/activity.ts